import gql from "graphql-tag";
import { useQuery, useMutation } from "@apollo/react-hooks";

const GET_NODE = gql`
  query node($id: ID!) {
    node(id: $id) {
      id
      coordinates {
        lat: latitude
        lng: longitude
      }
      edges {
       id
       nodeOne
       nodeTwo
       distance
      }
    }
  }
`;

const GET_NODES = gql`
  query nodes {
    nodes {
      id
      coordinates {
        lat: latitude
        lng: longitude
      }
    }
  }
`;

const CREATE_NODE = gql`
  mutation createNode($coordString: String, $withEdge: Boolean!) {
    createNode(data: {
      coordString: $coordString
    }, withEdge: $withEdge) {
      id
    }
  }
`;

const DELETE_NODE = gql`
  mutation deleteNode($id: ID!) {
    deleteNode(id: $id) {
     id
    }
  }
`;

export function useGetNode(id:string, options:object = {}) {
  return useQuery(GET_NODE, {
    fetchPolicy: 'no-cache',
    ...options,
    variables: {
      id: id,
    }
  });
}

export function useGetNodes(options:object = {}) {
  return useQuery(GET_NODES, { fetchPolicy: 'no-cache', ...options });
}

export function useCreateNode() {
  const [createNodeMutation] = useMutation(CREATE_NODE);

  const createNode = async (coordinateString:string, withEdge:boolean = false) => {
    return await createNodeMutation({
      variables: { coordString: coordinateString, withEdge },
    } as any);
  };

  return createNode;
}

export function useDeleteNode(node:string) {
  const [deleteNodeMutation] = useMutation(DELETE_NODE);

  const deleteNode = async (id:string = node) => {
    return await deleteNodeMutation({
      variables: { id: id },
    } as any);
  };

  return deleteNode;
}

